import script from "./customFieldRender.vue?vue&type=script&setup=true&lang=js"
export * from "./customFieldRender.vue?vue&type=script&setup=true&lang=js"

import "./customFieldRender.vue?vue&type=style&index=0&id=4f7d4e56&lang=css"

const __exports__ = script;

export default __exports__